import React from 'react'
import { Alert } from 'antd'

const FormError = (props) => {
  return <Alert message={props.children} type="error" className="field-error" showIcon />
}

export default FormError
